import { observer } from 'mobx-react-lite';
import { Menubar } from 'primereact/menubar';
import { Button } from 'primereact/button';
import type { ApplicationSdk } from './core/sdk';

const isNavigationItemActive = (sdk: ApplicationSdk, item: any) => {
    if (sdk.locationAction === 'iframe') {
        return sdk.locationParam === item.id;
    }
    return sdk.locationAction === item.id;
};

const Navigation = observer(({ sdk }: { sdk: ApplicationSdk }) => {
    const isAdminMode = sdk.adminMode || false;

    const adminToggleButton = (
        <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            {sdk.user?.isAdmin && (
                <Button
                    label={isAdminMode ? 'Manager' : 'Admin'}
                    icon={isAdminMode ? 'pi pi-users' : 'pi pi-cog'}
                    className="p-button-outlined p-button-sm"
                    onClick={() => sdk.toggleAdminMode()}
                />
            )}
            <img
                alt="logo"
                src={sdk.appConfig?.design?.logoUrl || '/logo_maten.png'}
                height="40"
                className="mr-2"
                style={{ marginRight: 16 }}
                onError={e => {
                    const target = e.target as HTMLImageElement;
                    target.src = '/logo_maten.png';
                }}
            />
        </div>
    );

    // Manager Navigation
    const managerItems = sdk.filteredMenuData.map((item: any) => ({
        label: item.label,
        id: item.key,
        icon: item.icon,
        command: () => {
            if (item.type === 'external') {
                window.open(item.path, '_blank');
            } else if (item.type === 'iframe') {
                sdk.routeTo(`/manager/iframe/${item.key}`);
            } else {
                // Default route navigation
                sdk.routeTo(item.path);
            }
        },
        right: item.permission ? item.permission : undefined,
    }));

    // Admin Navigation
    const adminItems = [
        {
            label: 'System Verwaltung',
            id: 'system',
            icon: 'pi pi-cog',
            command: () => {
                sdk.routeTo('/admin/system');
            },
        },
        {
            label: 'KI-Hub',
            id: 'kihub',
            icon: 'pi pi-android',
            command: () => {
                sdk.routeTo('/admin/kihub');
            },
        },
        {
            label: 'Menü',
            id: 'menu',
            icon: 'pi pi-android',
            command: () => {
                sdk.routeTo('/admin/menu');
            },
        },
        {
            label: 'Berechtigungen',
            id: 'permissions',
            icon: 'pi pi-shield',
            command: () => {
                sdk.routeTo('/admin/permissions');
            },
        },
        {
            label: 'Design',
            id: 'design',
            icon: 'pi pi-palette',
            command: () => {
                sdk.routeTo('/admin/design');
            },
        },
        // {
        //     label: 'Dokumente',
        //     id: 'documents',
        //     icon: 'pi pi-file',
        //     command: () => {
        //         sdk.routeTo('/admin/documents');
        //     },
        // },
    ];

    const currentItems = isAdminMode ? adminItems : managerItems;

    return (
        <Menubar
            end={adminToggleButton}
            className={isAdminMode ? 'p-menubar-2' : ''}
            data-test-id={'navigation-bar'}
            model={currentItems.map((item: any) => ({
                ...item,
                className: isNavigationItemActive(sdk, item) ? 'p-focus' : '',
            }))}
        />
    );
});

export default Navigation;
